import { AlertTriangle } from 'lucide-react';
import { Button } from './Button';
import { cn } from '@/lib/cn';

interface ErrorStateProps {
  title?: string;
  description?: string;
  onRetry?: () => void;
  className?: string;
}

export function ErrorState({
  title = 'Something went wrong',
  description = 'We couldn’t load this data. Try again in a moment.',
  onRetry,
  className,
}: ErrorStateProps) {
  return (
    <div className={cn('flex flex-col items-center justify-center gap-3 rounded-lg border border-dashed border-danger/40 bg-danger/5 px-6 py-12 text-center', className)}>
      <AlertTriangle className="h-5 w-5 text-danger" aria-hidden />
      <div className="space-y-1">
        <p className="text-sm font-medium text-danger">{title}</p>
        <p className="max-w-sm text-xs text-muted-foreground">{description}</p>
      </div>
      {onRetry ? (
        <Button size="sm" variant="outline" onClick={onRetry}>
          Retry
        </Button>
      ) : null}
    </div>
  );
}
